import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { ContentTemplate, Grid, HeaderTemplate, Stepper } from 'web-library';
import { useRegisterResitRoute } from '../../logic/useResit';
import ConfirmParticulars from './ConfirmParticulars';
import ReviewAndPay from './ReviewAndPay';
import SelectSubject from './SelectSubject';
import RouteKey from '../../../../routes/key';

const { error: errorRoute } = RouteKey.child;

const useStyles = makeStyles()((theme) =>
({
  container: {
    alignItems: 'center',
  },
  stepperContainer: {
    marginTop: theme.spacing(5),
    paddingTop: theme.spacing(2),
    backgroundColor: theme.color.background.bgAlt,
  },
  stepContent: {
    backgroundColor: theme.color.background.bgAlt,
  },
}));

const RegisterResitRoute = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  const routeSteps = [
    {
      label: t('resit->>RegisterResit.Select Subject(s)'),
    },
    {
      label: t('resit->>RegisterResit.Confirm Particulars'),
    },
    {
      label: t('resit->>RegisterResit.Review & Pay'),
    },
  ];

  const { path, url } = useRouteMatch();
  const {
    step,
    localRouteKey,
    selectedSubjects,
    toStep1,
    toStep2,
    toStep3,
  } = useRegisterResitRoute(url);

  return (
    <>
      <HeaderTemplate>
        <Stepper activeStep={step} steps={routeSteps} />
      </HeaderTemplate>

      <Switch>
        <Route exact path={`${path}`}>
          <Redirect to={`${path}/${localRouteKey.selectSubjects}`} />
        </Route>

        <Route path={`${path}/${localRouteKey.selectSubjects}`}>
          <Grid xs={12} className={classes.stepContent}>
            <SelectSubject next={toStep2} />
          </Grid>
        </Route>

        <Route path={`${path}/${localRouteKey.confirmParticulars}`}>
          <ContentTemplate>
            <Grid xs={12} className={classes.stepContent}>
              <ConfirmParticulars
                previous={toStep1}
                next={toStep3}
                selectedSubjects={selectedSubjects || []}
              />
            </Grid>
          </ContentTemplate>
        </Route>

        <Route path={`${path}/${localRouteKey.reviewPay}`}>
          <ContentTemplate type="full">
            <Grid xs={12} className={classes.stepContent}>
              <ReviewAndPay previous={toStep2} />
            </Grid>
          </ContentTemplate>
        </Route>

        {/* <Route path={`${path}/${RouteKey.confirmParticulars}`}>
          <Grid xs={8} className={classes.stepContent}>
            <Detail next={toStep3} previous={toStep1} selectedUser={selectedSubjects} />
          </Grid>
        </Route>

        <Route path={`${path}/${RouteKey.reviewPay}`}>
          <Grid xs={8} className={classes.stepContent}>
            <Confirmation />
          </Grid>
        </Route> */}

        <Route path="*" exact>
          <Redirect to={`/${errorRoute}`} />
        </Route>
      </Switch>
    </>
  );
};

export default RegisterResitRoute;
